export const tabItems = [
  {
    label: "Details",
    tabindex: 0,
  },
  {
    label: "Applications",
    tabindex: 1,
  },
  {
    label: "Users",
    tabindex: 2,
  },
];
